<template>
  <b-container>
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            Document Summarization
          </h1>
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            INPUT FORM
          </h4>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <div class="col-12">
            <label class="textarea-input" for="input-service-id">Upload file:</label>
            <input ref="fileupload" multiple="multiple" class="mb-2 sm-input" type="file" accept=".png, .jpg, .jpeg, .json, .txt, .docx, .pdf" @change="onChooseImage">
          </div>
          <CCol col="12" class="form-button">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit" class="btn">
                  <span><img src=""></span>Summarize
                </router-link>
              </div>
            </div>
          </CCol>
        </CRow>
      </div>
      <CRow v-if="resultSummary.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            SUMMARY RESULT
          </h4>
        </CCol>
      </CRow>
      <div v-if="resultSummary.length > 0" class="content">
        <CRow>
          <CCol xm="12" class="d-flex justify-content-center my-2">
            <b-alert v-html="resultSummary" show></b-alert>
          </CCol>
        </CRow>
      </div>
      <CRow class="mt-5" v-if="resultNER.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            KEYWORDS
          </h4>
        </CCol>
      </CRow>
      <div v-if="resultNER.length > 0" class="content">
        <CRow>
          <div class="col-12">
            <b-table small
              :fields="fields"
              :items="resultNER"
            >
              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>
            </b-table>
          </div>
        </CRow>
      </div>
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      isLoading: false,
      showErrorModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      inputFile: null,
      fields: [
          { key: 'index', label: '' },
          { key: 'category', label: 'Kategori' },
          { key: 'content', label: 'Konten' },
      ],
      resultSummary: "",
      resultNER: [],

      token: ""
    }
  },
  methods: {
    onChooseImage(e){
      this.inputFile = e.target.files
    },
    onClickSubmit(){
      this.isLoading = true
      let payload = new FormData()
      for (const file of this.inputFile) {
        payload.append("files", file)
      }
      let urlUpload = "https://5323-103-82-14-202.ngrok-free.app/document/add-document-with-gpt"
      let runUpload = this.$axios.post(urlUpload, payload, {
        headers: {
          "Authorization": this.token
        }
      }).then((response) => {
        if (response.status === 200 && response.data.success){
          this.resultSummary = response.data.message
        }
        else {
          this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = false
          this.showErrorModal = true
        }
      })

      this.isLoading = false

      // Promise.all([runUpload]).then(() => {
      //   // this.inputText = ""
      // })
      // .catch(error => {
      //   if(error.response) this.errorLabel = error.response.data.reason
      //   else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
      //   this.errorReload = false
      //   this.showErrorModal = true
      // })
      // .finally(() => {
      //   this.isLoading = false
      // })
    },

    login(){
      this.isLoading = true
      let urlLogin = "https://5323-103-82-14-202.ngrok-free.app/auth/login"
      let payload = new FormData()
      payload.set('username', 'mike')
      payload.set('password', 'P@ssw0rd')

      let runLogin = this.$axios.post(urlLogin, payload).then((response) => {
        if (response.status === 200 && response.data.success){
          this.token = "Bearer " + response.data.data.access_token
        }
        else {
          this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = false
          this.showErrorModal = true
        }
      })
      Promise.all([runLogin]).then(() => {
        // this.inputText = ""
      })
      .catch(error => {
        if(error.response) this.errorLabel = error.response.data.reason
        else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  },
  created(){
    this.login()
  } 
}
</script>